export const permissoesRotas = {
  // Relatorio de Acompanhamento
  criaRelatorioAcompanhamento: ['admin', 'cria_formulario'],
  responderPendencia: ['admin', 'resp_pend_form'],
  acompanharPendencias: ['admin', 'acomp_pend'],
  //  Indicadores
  informarIndicadores: ['admin', 'cria_indicador'],
  ajustarIndicadores: ['admin'],
  // Downloads
  downloadRelatorios: ['admin', 'download_relatorios'],
  downloadRelatorioAcompanhamento: ['admin', 'cria_formulario'],
  // Admin
  gerarRelatorios: ['admin'],
  configuracoesGerais: ['admin'],
  // Testes
  testes: ['admin'],
};
